import { render, staticRenderFns } from "./applyDialog.vue?vue&type=template&id=36a1ec6b&scoped=true"
import script from "./applyDialog.vue?vue&type=script&lang=js"
export * from "./applyDialog.vue?vue&type=script&lang=js"
import style0 from "./applyDialog.vue?vue&type=style&index=0&id=36a1ec6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a1ec6b",
  null
  
)

export default component.exports